import { forwardRef, useEffect, useState } from 'react';

const ImageViewer = forwardRef(({ src, alt = '', ...props }, ref) => {
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    if (src) {
      const byteArray = new Uint8Array(src);
      const blob = new Blob([byteArray], { type: 'image/jpeg' }); // change to 'image/png' if needed
      const url = URL.createObjectURL(blob);
      setImageSrc(url);

      // Clean up when component unmounts
      return () => URL.revokeObjectURL(url);
    }
  }, [src]);

  return <img src={imageSrc} alt={alt} {...props} ref={ref} />;
});

ImageViewer.displayName = 'ImageViewer';
export default ImageViewer;
